import React from 'react'

function Photo ({ items }) {
  function checkFileType (url) {
    const fileExtension = url.split('.').pop().toLowerCase()

    if (fileExtension === 'pdf') {
      return 'PDF'
    } else if (['jpeg', 'jpg', 'png', 'gif', 'bmp'].includes(fileExtension)) {
      return 'Image'
    } else {
      return 'Unknown'
    }
  }
  return (
    <>
      <div className=''>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <tbody>
            <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
              <th
                scope='row'
                className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
              >
                360 URL
              </th>
              <th
                scope='row'
                className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
              >
                {items?.url ? (
                  <a
                    href={items?.url}
                    className='text-blue-500'
                    target='_blank'
                    rel='noreferrer'
                  >
                    {' '}
                    360 View
                  </a>
                ) : (
                  'N/A'
                )}
              </th>
            </tr>
            <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
              <th
                scope='row'
                className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
              >
                Video URL
              </th>
              <th
                scope='row'
                className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
              >
                <div className='flex '>
                  {items?.videos && items?.videos.length > 0
                    ? items?.videos?.map((video, index) => (
                        <a
                          key={video.id}
                          href={video}
                          target='_blank'
                          className={`text-blue-500 ${index === 1 && 'ml-2'}`}
                          rel='noreferrer'
                        >
                          View
                        </a>
                      ))
                    : 'N/A'}
                </div>
              </th>
            </tr>
          </tbody>
        </table>

        <div className='photos'>
          <div className='text-50px font-medium text-lg p-6 pb-0'>Photos</div>
          <div className='images-container pl-6 pr-4 flex flex-wrap'>
            {items?.photos && items?.photos?.length > 0
              ? items?.photos?.map((val, ind) => (
                  <div
                    className='item object-cover w-24 h-24 border overflow-hidden m-2'
                    key={val.id}
                  >
                    <img
                      src={val.url} // Assuming the URL property is named 'url'
                      alt={val.description || 'Photo'}
                      className='object-cover w-24 h-24'
                    />
                  </div>
                ))
              : 'No photo found'}
          </div>
        </div>

        <div className='videos'>
          <div className='text-50px font-medium text-lg p-6 pb-0'>Videos</div>
          <div className='images-container pl-6 pr-4 flex flex-wrap'>
            {Array.isArray(items?.video) && items?.video?.length > 0
              ? items?.video?.map((val, ind) => (
                  <div
                    key={ind}
                    className='item w-[270px] h-full border   m-2 '
                  >
                    {' '}
                    <video controls>
                      <source src={val} type='video/mp4' />
                      Your browser does not support the video tag.{' '}
                    </video>{' '}
                  </div>
                ))
              : 'No video found'}
            {/* <div className='item w-[270px] h-[160px] border   m-2 '>
              <video controls>
                <source src={DefaultVideo} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </div> */}
          </div>
        </div>
        <div className='floor-plan'>
          <div className='text-50px font-medium text-lg p-6 pb-0'>
            Floor Plan
          </div>
          <div className='images-container pl-6 pr-4 flex flex-wrap'>
            {Array.isArray(items?.floorPlan) && items?.floorPlan.length > 0
              ? items.floorPlan.map((val, ind) => {
                  const fileType = checkFileType(val?.image)

                  if (fileType === 'Image') {
                    return (
                      <div className='item object-cover m-2' key={ind}>
                        <img
                          src={val?.image}
                          alt='details'
                          className='object-cover w-24 h-24'
                        />
                        <h3 className='m-2'>{val?.title}</h3>
                      </div>
                    )
                  } else if (fileType === 'PDF') {
                    return (
                      <div className='item object-cover m-2' key={ind}>
                        <a
                          href={val?.image}
                          target='_blank'
                          className='p-2 bg-gray-100 rounded-sm'
                          rel='noreferrer'
                        >
                          {val?.title}
                        </a>
                      </div>
                    )
                  } else {
                    return 'No floor plan found'
                  }
                })
              : 'No floor plan found'}
          </div>
        </div>
      </div>
    </>
  )
}

export default Photo
